// extracted by mini-css-extract-plugin
export var drawerPaper = "_1t-0";
export var itemImage = "_1t-1";